var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%","height":"100%"}},[_c('ManageUser'),_c('Share'),_c('Map'),_c('SearchGeneralGeodir'),_c('SideNav'),_c('DataQuality'),_c('StreetView'),_c('Here'),_c('ButtonForm'),_c('BannerUbicasa')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }